module.exports = {"621227100":"城关镇","621227101":"伏家镇","621227102":"江洛镇","621227103":"泥阳镇","621227104":"柳林镇","621227105":"嘉陵镇","621227106":"永宁镇","621227107":"银杏树镇","621227108":"水阳镇","621227109":"栗川镇","621227110":"麻沿河镇","621227111":"高桥镇","621227112":"大河店镇","621227208":"榆树乡","621227211":"虞关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621227.json
// module id = 2748
// module chunks = 0